import React, { useState } from "react";
import images from "../../../utils/images";
import Hr from "../../UI/Hr";
import Button from "../../UI/Button";
import _ from "lodash";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import { Checkbox, Radio, RadioGroup } from "../../../component-library";
import { isUserPeerOrCM } from "../../../redux/actions/auth";

const CalendarPreferencesModal = (props) => {
  const { preferences, updatePreferences, closeModal } = props;

  const [tempPreferences, setTempPreferences] = useState(_.cloneDeep(preferences));

  const calendarViews = [
    { label: "Day", value: "DAY" },
    { label: "Week", value: "WEEK" },
  ];

  const calendarEvents = [
    { label: "Scheduled", value: "scheduled" },
    { label: "Cancelled", value: "cancelled" },
    { label: "Rescheduled", value: "rescheduled" },
    { label: "No Show", value: "no_show" },
  ];

  const handleCalendarViewChange = (e) => {
    const updatedPreferences = _.cloneDeep(tempPreferences);
    _.set(updatedPreferences, "calendar.view", e.target.value);
    setTempPreferences(updatedPreferences);
  };

  const handleCalendarEventChange = (event) => {
    const updatedPreferences = _.cloneDeep(tempPreferences);
    const events = updatedPreferences.calendar?.events || [];

    if (event.target.checked) {
      if (!events.includes(event.target.value)) {
        events.push(event.target.value);
      }
    } else {
      const index = events.indexOf(event.target.value);
      if (index > -1) {
        events.splice(index, 1);
      }
    }

    _.set(updatedPreferences, "calendar.events", events);
    setTempPreferences(updatedPreferences);
  };

  const onSave = () => {
    updatePreferences(tempPreferences);
    closeModal();
  };

  return (
    <div
      className="insurancePopUp position-fixed d-flex align-items-center tw:justify-center"
      data-public={"true"}
    >
      <div className="insurancePopUp__inner d-flex flex-column position-absolute">
        <div className="d-flex justify-content-between">
          <h1 className="fs-16 tw:font-bold p-3 mb-0">Calendar Preferences</h1>
          <img
            className="fs-16 tw:font-bold p-2 pointer"
            src={images("./icons/grey-x-circle.svg")}
            onClick={closeModal}
            alt={"Close"}
          />
        </div>
        <Hr />
        <div className="p-3">
          <div className="mt-4">
            <h3 className="fs-15 tw:font-bold">Default Calendar View</h3>
            <RadioGroup
              name="calendarView"
              value={tempPreferences.calendar?.view || "DAY"}
              onChange={handleCalendarViewChange}
              className="mt-2"
            >
              {calendarViews.map((view) => (
                <Radio
                  key={view.value}
                  value={view.value}
                  label={view.label}
                  testId={`CalendarView_${view.value}`}
                />
              ))}
            </RadioGroup>
          </div>

          {!isUserPeerOrCM() && (
            <div className="mt-4">
              <h3 className="fs-15 tw:font-bold">Events Shown by Default</h3>
              <div className="mt-2">
                {calendarEvents.map((event) => (
                  <div key={event.value}>
                    <Checkbox
                      name={`calendarEvent_${event.value}`}
                      value={event.value}
                      label={event.label}
                      checked={(tempPreferences.calendar?.events || []).includes(event.value)}
                      onChange={handleCalendarEventChange}
                      testId={`CalendarEvent_${event.value}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <Hr />
        <div className="p-3 d-flex justify-content-end">
          <Button
            type="button"
            className="Btn Btn--otl-pri Btn-sm mx-2"
            onClick={closeModal}
            {...getAutomationDataAttr("PreferencesCancelButton")}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="Btn Btn--pri Btn-sm mx-2"
            onClick={onSave}
            {...getAutomationDataAttr("PreferencesSaveButton")}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CalendarPreferencesModal;
